export default "__VITE_ASSET__DdiQcscG__"